import React from 'react';
import { Table, Button } from 'reactstrap';
import Row from '../Row';
import $ from 'jquery';
import DropZoneTable from './DropZoneTable';
import { connect } from 'react-redux';
import UpArrow from '@mui/icons-material/KeyboardArrowUp';
import DownArrow from '@mui/icons-material/KeyboardArrowDown';

class TemplateTable extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            currentPage: 0,
            numPages: 0,
            pageLimit: 10,
            rowsShown: 9,
            sortConfig: { key: null, direction: 'asc' },
            ...props,
            filters: {
                templateName: '',
                templateFolder: '',
                templateLanguage: '',
                templateVersion: '',
                templateLastUpdated: ''
            },
            showFilters: false
        }

        this.goToNextPage = this.goToNextPage.bind(this)
        this.goToPrevPage = this.goToPrevPage.bind(this)
    }

    componentDidUpdate(prevProps) {  
        if(this.props.logs.length !== prevProps.logs.length){
            let noPages = Math.ceil(this.props.logs.length / this.state.pageLimit)
            this.setState({
                numPages: noPages,
                currentPage: 0
            })
        }
    }

    handleFilterChange = (key, value) => {
    this.setState((prevState) => ({
        filters: {
            ...prevState.filters,
            [key]: value
        },
        currentPage: 0 // optional: reset to first page on filter
        }));
    };

    toggleFilters = () => {
        this.setState((prevState) => ({
            showFilters: !prevState.showFilters
        }));
    };

    clearAllFilters = () => {
        this.setState({
            filters: {
                templateName: '',
                templateFolder: '',
                templateLanguage: '',
                templateVersion: '',
                templateLastUpdated: ''
            },
            currentPage: 0 // optional: reset to first page
        });
    };



    goToNextPage() {
        let page = this.state.currentPage + 1
        if (page < this.state.numPages)
            this.setState({
                currentPage: page
            })
    }

    goToPrevPage() {
        let page = this.state.currentPage - 1
        if (page >= 0)
            this.setState({
                currentPage: page
            })
    }

    onSort = (key) => {
        this.setState((prevState) => {
            const direction = prevState.sortConfig.key === key && prevState.sortConfig.direction === 'asc' ? 'desc' : 'asc';

            const logs = [...(prevState.logs.length ? prevState.logs : this.props.logs)];

            const sortedRows = [...logs].sort((a, b) => {
                let aValue = a[key];
                let bValue = b[key];

                // Fallback in case of undefined values
                if (aValue == null) aValue = '';
                if (bValue == null) bValue = '';

                if (typeof aValue === 'string') aValue = aValue.toLowerCase();
                if (typeof bValue === 'string') bValue = bValue.toLowerCase();

                if (aValue < bValue) return direction === 'asc' ? -1 : 1;
                if (aValue > bValue) return direction === 'asc' ? 1 : -1;
                return 0;
            });

            return {
                logs: sortedRows,
                sortConfig: { key, direction }
            };
        });
    };

    renderSortableFilterableHeader = (filterKey, onSort, sortConfigKey, labelKey, labelFallback) => {
      const isSorted = this.state.sortConfig.key === sortConfigKey;
      const sortArrow = isSorted
      ? this.state.sortConfig.direction === 'asc'
        ? <UpArrow />
        : <DownArrow />
      : null;

      const label = this.getLocalizedLabel(labelKey, labelFallback);

      return (
      <th
        key={filterKey}
        className="s-grid-title-cell"
        style={{ cursor: 'pointer' }}
        onClick={() => this.onSort(onSort)}
      >
        <div className="s-grid-title-cell-filter">
          {label} {sortArrow}
        </div>
        <div>
          {this.state.showFilters && (
            <input
              className="form-control form-control-sm"
              type="text"
              placeholder="Start typing to search..."
              value={this.state.filters[filterKey] || ''}
              onMouseDown={(e) => e.stopPropagation()}
              onChange={(e) => this.handleFilterChange(filterKey, e.target.value)}
            />
          )}
        </div>
      </th>
      );
    };

    getLocalizedLabel = (key, fallback) => {
      const labelObj = this.props.userReducer.localisation[key];
      return labelObj?.element_lang || fallback;
    };

    render() {

        var b = true
        let grid_css
        let id
        let rows = []
        let pageignation = <div />
        let is_checked = false;

        const { localisation } = this.props.userReducer

        const filtersActive = Object.values(this.state.filters).some(
            val => val.trim() !== ''
        );

        let startItem = (this.state.currentPage * this.state.rowsShown) + this.state.currentPage;
        let endItem = startItem + this.state.rowsShown;

        let logsToRender = (this.state.logs?.length ? this.state.logs : this.props.logs).filter(file => {
            const { filters } = this.state;

            const matches = (field, value) =>
                field?.toString().toLowerCase().includes(value.toLowerCase());

            const extractDatePortion = (dateStr) => {
                if (!dateStr) return '';
                const date = new Date(dateStr);

                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                const year = String(date.getFullYear()).slice(2); // Get last 2 digits of year

                return `${day}/${month}/${year}`; // e.g. "03/04/25"
            };


            const userInput = filters.templateLastUpdated.trim();
            const matchDate = userInput
                ? extractDatePortion(file.updatedatetime).includes(userInput)
                : true;

            return (
                matches(file.template, filters.templateName) &&
                matches(file.folder, filters.templateFolder) &&
                matches(file.language, filters.templateLanguage) &&
                matches(file.version, filters.templateVersion) &&
                matchDate
            );
        });


        if (logsToRender) {
            logsToRender.forEach((row, i) => {
            if (i < startItem || i > endItem)
                return

            grid_css += b ? "s-grid-row" : " s-grid-row s-record-alt";
            b = !b

            id = "P" + row._id

            if (this.props.associated_templates.length > 0) {
                var found = this.props.associated_templates.find(element => {
                    return element.id == row._id || element.id == row.parentId;
                });

                rows.push(
                    <Row 
                        useFilteredTemplates={this.props.useFilteredTemplates} 
                        editorpopover 
                        expandOpen={found ? (found.associated.length > 0 ? true : false) : false} 
                        rightAlign={[5]} 
                        viewPortfolio={false} 
                        onRowClicked={this.props.onRowClicked} 
                        expandLogs={this.props.expandLogs} 
                        is_checked={is_checked} 
                        checked={this.props.checked} i={i} 
                        checkChange={this.props.checkChange} 
                        refresh={this.props.refresh} 
                        id={id} 
                        fileid={row._id} 
                        tr_css={grid_css} 
                        filename={row.template} 
                        filetype={row.folder} 
                        version={row.language} 
                        user={row.version} 
                        dated={row.updatedatetime} 
                        file={row} 
                        amendLogs={this.amendLogs} 
                        columnConfig={this.props.columnConfig}
                    />);


                if (found && found.associated.length > 0)
                    found.associated.forEach(assoc_row => {
                        let row_id = "P" + assoc_row._id
                        if (assoc_row._id !== row._id)
                            rows.push(
                                <Row 
                                    useFilteredTemplates={this.props.useFilteredTemplates} 
                                    editorpopover 
                                    editorpopoverchild 
                                    rightAlign={[5]} 
                                    viewPortfolio={false} 
                                    onRowClicked={this.props.onRowClicked} 
                                    is_checked={is_checked} 
                                    refresh={this.props.refresh} 
                                    id={row_id} 
                                    fileid={assoc_row._id} 
                                    tr_css={""} 
                                    filename={assoc_row.template} 
                                    filetype={assoc_row.folder} 
                                    version={assoc_row.language} 
                                    user={assoc_row.version} 
                                    dated={assoc_row.updatedatetime} 
                                    file={assoc_row}
                                    columnConfig={this.props.columnConfig}
                                    />);
                    })
            }
            else {
                rows.push(
                    <Row 
                        useFilteredTemplates={this.props.useFilteredTemplates} 
                        editorpopover 
                        expandOpen={found ? (found.associated.length > 0 ? true : false) : false} 
                        rightAlign={[5]} 
                        viewPortfolio={false} 
                        onRowClicked={this.props.onRowClicked} 
                        expandLogs={this.props.expandLogs} 
                        is_checked={is_checked} 
                        checked={this.props.checked} i={i} 
                        checkChange={this.props.checkChange} 
                        refresh={this.props.refresh} 
                        id={id} 
                        fileid={row._id} 
                        tr_css={grid_css} 
                        filename={row.template} 
                        filetype={row.folder} 
                        version={row.language} 
                        user={row.version} 
                        dated={row.updatedatetime} 
                        file={row} 
                        amendLogs={this.amendLogs}
                        columnConfig={this.props.columnConfig}
                        />);
            }
            });
        }


        

        if (this.props.logs && this.props.userReducer.localisation) {
            pageignation = <div>
                <div class="s-array-topbar-right">
                    <label class="s-pager-range">{this.props.logs.length > 1 ? localisation['table_header_records'] ? this.props.logs.length + ' ' + localisation['table_header_records'].element_lang : '' : localisation['table_header_record'] ? this.props.logs.length + ' ' + localisation['table_header_record'].element_lang : 'Records'}</label>
                    <label class="s-pager-range">|</label>
                    <label class="s-pager-size-label">Page {this.state.currentPage + 1} / {this.state.numPages}</label>
                    <div class="s-pager">
                        <a onClick={this.goToPrevPage} class="s-pager-link s-fonticon-btn s-btn-previous"></a>
                        <a onClick={this.goToNextPage} class="s-pager-link s-fonticon-btn s-btn-next"></a>
                    </div>
                    <a onClick={this.props.refresh} class="s-mn-list-btn s-pager-link s-fonticon-btn s-mn-link s-btn-refresh"></a>
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        style={{ marginLeft: '10px' }}
                        onClick={this.toggleFilters}
                        title={this.state.showFilters ? 'Hide search filters' : 'Show search filters'}
                    >
                        <i className="fa fa-filter" aria-hidden="true"></i>
                        <span style={{ marginLeft: '5px' }}>
                        {this.state.showFilters ? 'Hide search Filters' : 'Show search Filters'}
                        </span>
                    </button>
                    {filtersActive && (
                        <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={this.clearAllFilters}
                            title="Clear all filter fields"
                            style={{ marginLeft: '10px' }}
                        >
                            <i className="fa fa-times" aria-hidden="true" style={{ marginRight: '5px' }}></i>
                            Clear Filters
                        </button>
                    )}
                </div>
            </div>
        }


        return (
            <div class="s-slot-row">
                {pageignation}
                <Table responsive={true} hover={true} className="s-grid-table-head">
                    <tr>
                        {this.props.columnConfig?.expand && (
                            <th className="s-grid-title-cell s-grid-title-cell-small">
                                <div className="s-grid-title-empty"></div>
                            </th>
                        )}
                        {this.props.columnConfig?.actions && (
                            <th className="s-grid-title-cell s-grid-title-cell-small">
                                <div className="s-grid-title-empty"></div>
                            </th>
                        )}
                        {/* filterKey, onSort, sortConfigKey, labelKey, labelFallback */}
                        {this.renderSortableFilterableHeader('templateName', 'template', "template", "table_header_name", "Name")}
                        {this.renderSortableFilterableHeader('templateFolder', 'folder', "folder", "table_header_folder", "Folder")}
                        {this.renderSortableFilterableHeader('templateLanguage', 'language', "language", "table_header_language", "Language")}
                        {this.renderSortableFilterableHeader('templateVersion', 'version', "version", "table_header_version", "Version")}
                        {this.renderSortableFilterableHeader('templateLastUpdated', 'updatedatetime', "updatedatetime", "table_header_last_updated", "Last Updated")}
                    </tr>
                </Table>
                <div class="s-grid-slot-body">
                    <DropZoneTable refresh={this.props.refresh} rows={rows} />
                </div>
            </div>
        );
    }
}

export default connect(state => state)(TemplateTable);
